<div class="popup">
  <h2 i18n="@@AddProductToSpecificationManually">Добавить товар в корзину</h2>
  <p i18n="@@AddProductManuallyDesc">Введите в поле артукул или название товара и, через пробел, нужное количество. Каждый товар — с новой строки. Можно скопировать 2 соседние колонки из таблицы Excel.
  </p>
  <form aria-labelledby="title" (ngSubmit)="onSubmit()">
    <div class="form-content">
      @if (rows$ | async; as rows) {
        <p i18n>Всего {{ createLabel(rows.headerAmount.length, 'товар|товара|товаров') }}</p>
      }
      <textarea fullWidth nbInput name="text" [formControl]="inputFormControl" cdkTextareaAutosize cdkAutosizeMinRows="5"></textarea>
    </div>
    <nb-card-footer>
      <button nbButton
        status="primary"
        size="large"
        i18n="@@Send"
        nbSpinnerStatus="control"
        [nbSpinner]="submitted"
        [disabled]="!inputFormControl.valid || submitted"
        type="submit">
          Добавить
        </button>
      <button type="button" size="large" nbButton i18n="@@Cancel" (click)="close()">
          Отмена
      </button>
    </nb-card-footer>
  </form>
</div>
